import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ListChecks, ShoppingBag, History, User } from 'lucide-react';
import Player from 'lottie-react';
import checkAnim from '../assets/lottie/check.json';
import cartAnim from '../assets/lottie/shopping-cart.json';
import clockAnim from '../assets/lottie/clock.json';
import userAnim from '../assets/lottie/user.json';
import { useTranslation } from '../i18n/LocaleContext';

const BottomNav = () => {
  const location = useLocation();
  const { t } = useTranslation();

  // Idle = lucide outline; active = useAnimations Lottie plays once on arrival.
  // Support lives in the floating chat ball, not the tab bar.
  const tabs = [
    { path: '/trang-chu', label: t('tasksTab'), icon: ListChecks, lottie: checkAnim },
    { path: '/don-hang', label: t('orders'), icon: ShoppingBag, lottie: cartAnim },
    { path: '/lich-su', label: t('history'), icon: History, lottie: clockAnim },
    { path: '/vi', label: t('myProfile'), icon: User, lottie: userAnim }
  ];

  const activeIndex = tabs.findIndex((tab) => location.pathname === tab.path);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-md bg-white/95 backdrop-blur border-t border-black/5 safe-bottom">
        <div className="relative flex items-stretch justify-around px-1 py-1.5">
          {/* Sliding active pill — springs from tab to tab (Tinder-style) */}
          {activeIndex >= 0 && (
            <span
              aria-hidden="true"
              className="absolute top-3 w-11 h-7 rounded-pill bg-brand-50 transition-[left] duration-300"
              style={{
                left: `calc(4px + ${activeIndex} * ((100% - 8px) / 4) + ((100% - 8px) / 4 - 44px) / 2)`,
                transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
              }}
            />
          )}
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path;
            const Icon = tab.icon;

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className="relative flex flex-col items-center justify-center gap-1 flex-1 py-1.5 group"
              >
                <span className={`w-11 h-7 flex items-center justify-center ${isActive ? 'text-brand-600' : ''}`}>
                  {isActive ? (
                    <Player
                      key={location.pathname}
                      animationData={tab.lottie}
                      loop={false}
                      autoplay
                      className="w-[22px] h-[22px] tab-lottie"
                    />
                  ) : (
                    <Icon
                      className="w-[20px] h-[20px] text-ink-muted transition-colors duration-200 group-hover:text-ink-secondary"
                      strokeWidth={1.9}
                    />
                  )}
                </span>
                <span
                  className={`text-[10px] transition-colors duration-200 ${
                    isActive ? 'font-semibold text-brand-700' : 'font-medium text-ink-muted'
                  }`}
                >
                  {tab.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
